<template>
  <div id="brandPopularModelsHorizontalScrollComponent" class="scroll-parent-element-component horizontal-scroll-component" :data-brand="this.$store.state.chosenBrand">
    <div id="brandPopularModelsHorizontalScroll" class="scroll-parent-element scroll-parent" data-has-scrollbar="true" data-scroll-region="min">
      <div class="scroll-horizontal">
        <div
          v-for="card in allCards"
          :key="card.id"
          class="bpm-card sokal-flex sokal-flex-col sokal-justify-between"
          :data-model="card.title"
        >
          <div class="bpm-inner sokal-flex sokal-flex-col sokal-gap">

            <div class="bpm-top" :style="{ backgroundColor: card.color }">
              <h5 class="year-brand sokal-mb-0">{{ card.prefix }}</h5>
              <h3 class="model sokal-m-0">{{ card.title }}</h3>

              <div
                class="bg-img sokal-my-1"
                :style="{ backgroundImage: `url(${card.image})` }"
              ></div>

              <div class="start-price sokal-my-2 sokal-mb-0">
                Starting at ${{ card.startPrice.toLocaleString() }}
              </div>

              <div class="vehicle-count sokal-my-2 sokal-mt-0">
                {{ card.count }} available
              </div>
            </div>

            <div class="bpm-bottom">
              <a href="#" class="view-btn">{{ getCtaLabel(card) }}</a>
            </div>

          </div>
        </div>
      </div>
      <div class="scroll-overlay scroll-overlay--left"></div>
      <div class="scroll-overlay scroll-overlay--right"></div>
      <div class="scroll-nav scroll-nav--left">
          <button type="button" class="scroll-nav-btn" data-scroll-parent="#brandPopularModelsHorizontalScroll" data-direction="left" tabindex="0"></button>
        </div>
      <div class="scroll-nav scroll-nav--right">
          <button type="button" class="scroll-nav-btn" data-scroll-parent="#brandPopularModelsHorizontalScroll" data-direction="right" tabindex="0"></button>
        </div>
    </div>
  </div>
</template>

<script>
  import "../../static/bootstrap-3.3.7-dist/js/bootstrap.min.js";
</script>

<script>
  import { resolveCJDRMake } from "../helpers/cjdrResolver";

  export default {
    props: ['images'],
    data() {
      return {
        activeBrand: this.$store.state.chosenBrand,
        cjdrMeta: {
          "wagoneer": {
            startPrice: `22K`,
            count: 39,
            color: "#4d6a79"
          },
          "ram 1500": {
            startPrice: '37K',
            count: 180,
            color: "#515749"
          },
          "dodge charger": {
            startPrice: '40K',
            count: 23,
            color: "#8f1125"
          },
          "chrysler pacifica": {
            startPrice: '34K',
            count: 78,
            color: "#245283"
          }
        }
      }
    },

    computed: {
      allCards() {
        if (this.activeBrand === "ford") {
          return this.fordCards;
        }

        if (this.activeBrand === "cjdr") {
          return this.cjdrCards;
        }

        return [];
      },
      fordCards() {
        const sedans = this.images.sedans || [];
        const suvs = this.images.suvs || [];
        const trucks = this.images.trucks || [];

        const findModel = (arr, name) => {
          const match = arr.find(v => v.modelName === name);
          return match ? match : {};
        };

        const mustang = findModel(sedans, "Mustang");
        const bronco = findModel(suvs, "Bronco");
        const explorer = findModel(suvs, "Explorer");
        const f150 = findModel(trucks, "F-150");
        const ranger = findModel(trucks, "Ranger");

        return [
          {
            id: "mustang",
            title: "Mustang",
            prefix: "New Ford",
            image: mustang.angleView,
            startPrice: 31920,
            count: 12,
            color: "#8c2c2d"
          },
          {
            id: "bronco",
            title: "Bronco",
            prefix: "New Ford",
            image: bronco.angleView,
            startPrice: 39995,
            count: 23,
            color: "#407246"
          },
          {
            id: "explorer",
            title: "Explorer",
            prefix: "New Ford",
            image: explorer.angleView,
            startPrice: 41745,
            count: 46,
            color: "#698ca1"
          },
          {
            id: "f150",
            title: "F-150",
            prefix: "New Ford",
            image: f150.angleView,
            startPrice: 38810,
            count: 78,
            color: "#052349"
          },
          {
            id: "ranger",
            title: "Ranger",
            prefix: "New Ford",
            image: ranger.angleView,
            startPrice: 33350,
            count: 37,
            color: "#3e434d"
          }
        ];
      },
      cjdrCards() {
        const suvs = this.images.suvs || [];
        const sedans = this.images.sedans || [];
        const trucks = this.images.trucks || [];

        const allGroups = [...suvs, ...sedans, ...trucks];

        const featuredModels = [
          "RAM 1500",
          "Wagoneer",
          "Dodge Charger",
          "Chrysler Pacifica"
        ];

        return allGroups
          .filter(v => featuredModels.includes(v.modelName))
          .sort((a, b) => {
            return featuredModels.indexOf(b.modelName) - featuredModels.indexOf(a.modelName);
          })
          .map(v => {
            const make = resolveCJDRMake(v.modelName);
            const key = v.modelName.toLowerCase();
            const meta = this.cjdrMeta[key] || {};

            return {
              id: key,
              make,
              title: make,
              image: v.angleViewAlt,
              startPrice: meta.startPrice || 0,
              count: meta.count || 25,
              color: meta.color || "#333",
            };
          });
      }
    },

    methods: {
      getCtaLabel(card) {
        if (this.activeBrand === "cjdr") {
          return `Shop ${card.make}`;
        }

        return "View Inventory";
      }
    },
    
    mounted() {
      (function($){
        const scrollElements = {
          init: function() {

            scrollElements.scrollNavInit();

            $('#brandPopularModelsHorizontalScrollComponent .scroll-parent').each(function(){
              
              let parent = '#' + $(this).attr('id');
              let element = parent + ' .scroll-horizontal';
              
              scrollElements.setDataRegion(parent, element);
              scrollElements.setDataHasScrollbar(parent, element);

              $(window).resize(function(){
                scrollElements.setDataHasScrollbar(parent, element);
              })
              
              $(element).on('scroll', function(){
                scrollElements.setDataRegion(parent, element);
              })

            })

            $('#brandPopularModelsHorizontalScrollComponent [data-toggle="tab"]').click(function(){
              setTimeout(function(){
                $('#brandPopularModelsHorizontalScrollComponent .tab-content .scroll-parent').each(function(){
                  let parent = '#' + $(this).attr('id');
                  let element = parent + ' .scroll-horizontal';
                  scrollElements.setDataHasScrollbar(parent, element);
                });
              }, 220);
            });

          }, 

          scrollNavInit: function() {
            
            $('#brandPopularModelsHorizontalScrollComponent .scroll-parent .scroll-nav').click(function(){

              $(this).find('.scroll-nav-btn').focus();
              
              let scrollParent = $(this).find('.scroll-nav-btn').attr('data-scroll-parent');
              let scrollTarget = scrollParent + ' .scroll-horizontal';
              let scrollContent = scrollTarget + ' > *';
              let distance = 0;

              $(scrollContent).each(function(){
                if ($(this).outerWidth() > distance) {
                  distance = $(this).outerWidth();
                }
              })
              
              let currentPosition = scrollElements.getPosition(scrollTarget);

              if ($(this).find('.scroll-nav-btn').attr('data-direction') === 'right') {
                scrollElements.animateScroll(scrollParent, scrollTarget, distance, currentPosition + distance);
              } else {
                scrollElements.animateScroll(scrollParent, scrollTarget, distance, currentPosition - distance);
              }
              
            })
          },

          setDuration: function(distance) {
            return Math.floor(distance / 0.7);
          }, 

          animateScroll: function(parent, element, distance, newPosition) {
            
            $(element).animate({
                scrollLeft: newPosition
            }, scrollElements.setDuration(distance));

            setTimeout(function(){
              scrollElements.setDataRegion(parent, element);
            }, scrollElements.setDuration(distance));
            
          }, 

          getPosition: function(element) {
            return $(element).scrollLeft();
          }, 

          getMaxScroll: function(element) {
            return document.querySelector(element).scrollWidth - (document.querySelector(element).clientWidth + 10);
          }, 

          setDataRegion: function(parent, element) {
            let maxScroll = scrollElements.getMaxScroll(element);
            let currentPosition = scrollElements.getPosition(element);

            if (currentPosition === 0 && maxScroll < 0) {
              $(parent).attr('data-scroll-region', 'min');
            } else if (currentPosition >= maxScroll) {
              $(parent).attr('data-scroll-region', 'max');
            } else if (currentPosition === 0) {
              $(parent).attr('data-scroll-region', 'min');
            } else {
              $(parent).attr('data-scroll-region', 'middle');
            }
          }, 

          setDataHasScrollbar: function(parent, element) {
            if (scrollElements.getPosition(element) === 0 && scrollElements.getMaxScroll(element) <= 0) {
              $(parent).attr('data-has-scrollbar', 'false');
            } else {
              $(parent).attr('data-has-scrollbar', 'true');
            }
          }
        }

        $(document).ready(scrollElements.init);

      })(jQuery)
    }

  }
</script>

<style scoped>
  #brandPopularModelsHorizontalScroll .bpm-card {
    padding: 10px;
    border: 2px solid #E5E5E5;
    border-radius: 20px;
    margin-right: 20px;
  }

  #brandPopularModelsHorizontalScroll .bpm-top {
    padding: 15px;
    color: #ffffff;
    border-radius: 20px;
    text-align: left;
    min-width: 22.5rem;
    min-height: 30rem;
  }

  #brandPopularModelsHorizontalScroll .bg-img {
    background-size: 105%;
    background-position: center;
    background-repeat: no-repeat;
    height: 225px;
  }

  #brandPopularModelsHorizontalScroll .start-price {
    font-size: 1.25rem;
    font-weight: 500;
  }

  #brandPopularModelsHorizontalScroll .vehicle-count {
    opacity: 0.7;
  }

  #brandPopularModelsHorizontalScroll .view-btn {
    background-color: #00142E;
    color: #ffffff;
    border-radius: 50px;
    padding: 12px;
    width: 100%;
    display: block;
    text-align: center;
    text-decoration: none;
    border: 2px solid #00142E;
  }
  #brandPopularModelsHorizontalScroll .view-btn:hover,
  #brandPopularModelsHorizontalScroll .view-btn:focus,
  #brandPopularModelsHorizontalScroll .view-btn:active {
    opacity: 0.9;
  }

  /* CDJR */

  #brandPopularModelsHorizontalScrollComponent[data-brand="cjdr"] .model {
    text-transform: uppercase;
    font-size: 3rem;
    font-weight: 700;
    font-family: "Barlow Condensed", sans-serif;
  }
  #brandPopularModelsHorizontalScrollComponent[data-brand="cjdr"] .view-btn {
    text-transform: uppercase;
    font-size: 1.5rem;
    font-weight: 700;
    font-family: "Barlow Condensed", sans-serif;
    border-radius: 8px;
  }
</style>

<style scoped>
  .horizontal-scroll-component {
    --scroll-overlay-gradient-rgba-min: rgba(255, 255, 255, 0);
    --scroll-overlay-gradient-rgba-max: rgba(255, 255, 255, 1);
    --overlay-color-min: var(--scroll-overlay-gradient-rgba-min, rgba(255, 255, 255, 0));
    --overlay-color-max: var(--scroll-overlay-gradient-rgba-max, rgba(255, 255, 255, 1))
  }

  .horizontal-scroll-component {
      overflow: hidden
  }

  .horizontal-scroll-component .scroll-parent {
      position: relative
  }

  .horizontal-scroll-component .scroll-horizontal {
      position: relative;
      background-color: #ffffff;
      overflow-x: scroll;
      width: 100%;
      margin: 0 auto;
      padding: 15px;
      white-space: nowrap;
      -ms-overflow-style: none;
      scrollbar-width: none
  }

  .horizontal-scroll-component .scroll-horizontal::-webkit-scrollbar {
      display: none
  }

  .horizontal-scroll-component .scroll-horizontal>* {
      display: inline-block;
      white-space: normal;
      vertical-align: middle
  }

  .horizontal-scroll-component .scroll-overlay,.horizontal-scroll-component .scroll-nav {
      width: 15%;
      height: 100%;
      position: absolute;
      top: 0;
      z-index: 1;
      -webkit-transition: all 0.1s ease;
      -moz-transition: all 0.1s ease;
      -o-transition: all 0.1s ease;
      transition: all 0.1s ease
  }

  .horizontal-scroll-component .scroll-overlay--left {
      left: -1%;
      background: linear-gradient(to left, rgba(255,255,255,0) 0%, rgba(255,255,255,0) 5%, #fff 100%);
      background: linear-gradient(to left, var(--overlay-color-min) 0%, var(--overlay-color-min) 5%, var(--overlay-color-max, #fff) 100%)
  }

  .horizontal-scroll-component .scroll-overlay--right {
      right: -1%;
      background: linear-gradient(to right, rgba(255,255,255,0) 0%, rgba(255,255,255,0) 5%, #fff 100%);
      background: linear-gradient(to right, var(--overlay-color-min) 0%, var(--overlay-color-min) 5%, var(--overlay-color-max, #fff) 100%)
  }

  .horizontal-scroll-component .scroll-nav {
      display: flex;
      flex-direction: column;
      justify-content: center
  }

  .horizontal-scroll-component .scroll-nav--right {
      right: 0;
      align-items: flex-end;
      padding-right: 1%
  }

  .horizontal-scroll-component .scroll-nav--left {
      left: 0;
      align-items: flex-start;
      padding-left: 1%
  }

  .horizontal-scroll-component .scroll-nav-btn {
      font-size: inherit;
      font-weight: 300;
      width: 30px;
      height: 30px;
      color: #ffffff;
      background-color: transparent;
      border: solid 2px transparent;
      border-radius: 100%;
      -webkit-transition: all 0.3s ease;
      -moz-transition: all 0.3s ease;
      -o-transition: all 0.3s ease;
      transition: all 0.3s ease;
      background-image: url("https://d2v1gjawtegg5z.cloudfront.net/assets/arrow-right-black-43b6b23ed61b72a8b073b2dfca374fb5ced57d6df7373641f7198deedda943b7.png");
      background-size: 35%;
      background-position: center;
      background-repeat: no-repeat
  }

  .horizontal-scroll-component[data-light-theme="true"] .scroll-nav-btn {
      -webkit-filter: invert(1);
      filter: invert(1)
  }

  .horizontal-scroll-component .scroll-nav--left .scroll-nav-btn {
      transform: rotateY(180deg)
  }

  .horizontal-scroll-component .scroll-nav-btn:hover {
      opacity: 0.7
  }

  .horizontal-scroll-component .scroll-nav-btn:focus,.horizontal-scroll-component .scroll-nav-btn:active {
      color: #ffffff;
      -webkit-transform: scale(1.5);
      transform: scale(1.5)
  }

  .horizontal-scroll-component .scroll-nav--left .scroll-nav-btn:focus,.horizontal-scroll-component .scroll-nav--left .scroll-nav-btn:active {
      -webkit-transform: rotateY(180deg) scale(1.5);
      transform: rotateY(180deg) scale(1.5)
  }

  .horizontal-scroll-component .scroll-parent[data-scroll-region="min"] .scroll-overlay--left,.horizontal-scroll-component .scroll-parent[data-scroll-region="max"] .scroll-overlay--right,.horizontal-scroll-component .scroll-parent[data-scroll-region="min"] .scroll-nav--left,.horizontal-scroll-component .scroll-parent[data-scroll-region="max"] .scroll-nav--right,.horizontal-scroll-component .scroll-parent[data-has-scrollbar="false"] .scroll-overlay,.horizontal-scroll-component .scroll-parent[data-has-scrollbar="false"] .scroll-nav {
      opacity: 0;
      visibility: hidden
  }

  .horizontal-scroll-component .scroll-parent[data-has-scrollbar="false"] .scroll-horizontal {
      text-align: center
  }

  @media (max-width: 767px) {
      .horizontal-scroll-component .scroll-nav-btn:hover,.horizontal-scroll-component .scroll-nav-btn:active,.horizontal-scroll-component .scroll-nav-btn:focus {
          opacity:1;
          color: #ffffff;
          -webkit-transform: scale(1.3);
          transform: scale(1.3)
      }

      .horizontal-scroll-component .scroll-nav--left .scroll-nav-btn:hover,.horizontal-scroll-component .scroll-nav--left .scroll-nav-btn:active,.horizontal-scroll-component .scroll-nav--left .scroll-nav-btn:focus {
          -webkit-transform: rotateY(180deg) scale(1.3);
          transform: rotateY(180deg) scale(1.3)
      }
  }
</style>